<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 1 1" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="1" height="1" [attr.fill]="stroke()"/>
  </svg>
</div>
